import {Glide, Controls, Breakpoints, Images, Swipe } from '../components/carousel'

// jQuery Plugin
require('./productZoom');
let isMobile = require('../utilities/clientSideUtil').isMobile;

var Zoom = function (GlideCarousel, Components, Events) {
    let activeZoomEl = null;
    const setactiveZoomEl = (el) => {
        if (activeZoomEl) {
            $(activeZoomEl).trigger('zoom.destroy');
        }
        if (el) {
            const $zoomImage = $(el);
            const zoomUrl = $(el).data('image-zoom-url');
            activeZoomEl = $zoomImage;
            $zoomImage.zoom({
                on: 'click',
                url: zoomUrl,
                magnify: 1,
                touch: true,
                onZoomIn: function () {
                    $(this).removeClass('zoom-out').addClass('zoom-in');
                    if (!isMobile()) {
                        $('.js-mbb-product-carousel .glide__arrows').removeClass('d-block').addClass('d-none');
                    }
                    $(this).on('mouseleave', function() {
                        GlideCarousel.enable();
                        $('.js-mbb-product-carousel .glide__arrows').removeClass('d-none').addClass('d-block');
                    })
                    $(this).on('mouseover', function() {
                        GlideCarousel.disable();
                        $('.js-mbb-product-carousel .glide__arrows').removeClass('d-block').addClass('d-none');
                    })
                    GlideCarousel.disable();
                },
                onZoomOut: function () {
                    $(this).removeClass('zoom-in').addClass('zoom-out');
                    if (!isMobile()) {
                        $('.js-mbb-product-carousel .glide__arrows').removeClass('d-none').addClass('d-block');
                        $(this).on('mouseleave mouseover', function() {
                            $('.js-mbb-product-carousel .glide__arrows').removeClass('d-none').addClass('d-block');
                        });
                    }
                    GlideCarousel.enable();
                }
            });

            return;
        }
        activeZoomEl = null;
    }
    const ImageZoom = {
        init(current) {
            const element = current;
            if (element) {
                setactiveZoomEl(element)
            }
        },
    }
    Events.on(['mount.after', 'run'], () => {
        ImageZoom.init(Components.Html.slides[GlideCarousel.index])
    })

    return ImageZoom
}

/**
 * Function to initialize GlideJs carousel on pdp page
 * @param {Object} containerEl - container element
 * 
 */
export function initializeCarousels(containerEl = document) {
    const carouselElements = containerEl.getElementsByClassName('js-mbb-product-carousel');
    Array.from(carouselElements).forEach(carousel => {
        var $glide = new Glide(carousel, {
            type: 'slider',
            gap: 0,
            animationDuration: 1000,
            rewind: false,
            startAt: 0,
            perView: 1,
            breakpoints: {
                768: {
                    rewind: false
                },
            }
        });

        $glide.mount({
            Controls,
            Breakpoints,
            Images,
            Zoom,
            Swipe           
        });
    });
};

/**
 * Dynamically creates GlideJs carousel from response containing images
 * @param {Object[]} imgs - Array of large product images,along with related information
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object[]} zoomImageUrls - Array of zoom product images,along with related information
 */
export function createCarousel(imgs, $productContainer, zoomImageUrls) {
    var carouselId = $productContainer.find('.glide').attr('id');
    if (imgs?.length < 1 || !carouselId) {
        return;
    }
    var $glideConfig = new Glide(`#${carouselId}`, {
        type: 'slider',
        gap: 0,
        animationDuration: 1000,
        rewind: false,
        startAt: 0,
        perView: 1,
        breakpoints: {
            768: {
                rewind: true
            },
        }
    })

    var $glide = $productContainer.find('.glide__track');

    $glideConfig.destroy();

    $glide.empty();

    var glideTrack = '<ul class="glide__slides">';

    imgs.forEach((img, index) => {
        glideTrack += `<li class='glide__slide zoom-image zoom-image-js ${index === 0 ? 'active' : ''} ${index === 0 ? 'glide__slide--active' : ''}' data-image-zoom-url='${zoomImageUrls[index].url}'>
                            <img src="${img.url}" class="d-block img-fluid" alt="${img.alt} image number ${index}" itemprop="image" />
                        </li>`;
    });

    glideTrack += '</ul>';

    $glide.append(glideTrack);

    $glideConfig.mount({
        Controls,
    });
}

/**
 * Dynamically updates thumbnails from response containing images
 * @param {Object[]} primaryImageUrlsSmall - Array of Small product images,along with related information
 * @param {jQuery} $thumbnailSection - DOM element for a given product thumbnail section
 */
export function updateThumbnail(primaryImageUrlsSmall, $thumbnailSection) {
    var thumbnailImages = '';

    if (primaryImageUrlsSmall?.length < 1 || $thumbnailSection ?.length < 1) {
        return;
    }

    $thumbnailSection.empty();

    primaryImageUrlsSmall.forEach((img, index) => {
        thumbnailImages += `<button class="glide__bullet ${(index === 0) ? 'glide__bullet--active' : ''}" data-glide-dir="=${index.toFixed(1)}" aria-label="Slide ${index + 1}">
                                <img src="${img.url}" class="d-block img-fluid" alt="${img.alt} thumbnail number ${index}" height="354" width="280" style="width: 280px" />
                            </button>`;
    });

    $thumbnailSection.append(thumbnailImages);

    initializeCarousels();
}